import { render, staticRenderFns } from "./GridRow.vue?vue&type=template&id=10351200&"
import script from "./GridRow.vue?vue&type=script&lang=js&"
export * from "./GridRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports